import React, { useMemo } from 'react';
import { useHits } from 'react-instantsearch';

import { SearchResults } from '@uncinc/react-searchkit';

import SearchAllContent from '../../SearchAllContent';
import createTopicalUrl from '../createTopicalUrl';
import renderRelatedHit from '../renderHit';
import RelatedContent from '..';
import {
  byTargetAudienceArticlesRequestOptions,
  byTargetAudienceEventsRequestOptions,
  hitsPerPage,
  searchSettings,
} from '../config';

interface RelatedContentByTargetAudienceProps {
  contentType: 'article' | 'event';
  targetAudienceId: number;
  targetAudienceName: string;
  title: string;
  className?: string;
}

const RelatedContentByTargetAudienceInner: React.FC<
Pick<RelatedContentByTargetAudienceProps, 'contentType' | 'targetAudienceName' | 'title' | 'className'>
> = ({
  contentType,
  targetAudienceName,
  title,
  className,
}) => {
  const { hits } = useHits();

  if (!hits.length) {
    return null;
  }

  const moreUrl = createTopicalUrl(contentType, 'targetAudience', targetAudienceName);

  return (
    <RelatedContent className={className}>
      <RelatedContent.Title title={title} />
      <SearchResults className="RelatedContent__items" renderItem={renderRelatedHit} />
      <RelatedContent.MoreButton url={moreUrl} />
    </RelatedContent>
  );
};

const RelatedContentByTargetAudience: React.FC<RelatedContentByTargetAudienceProps> = ({
  contentType,
  targetAudienceId,
  targetAudienceName,
  title,
  className,
}) => {
  const requestOptions = useMemo(
    () => (contentType === 'event'
      ? byTargetAudienceEventsRequestOptions(targetAudienceId)
      : byTargetAudienceArticlesRequestOptions(targetAudienceId)),
    [contentType, targetAudienceId],
  );

  return (
    <SearchAllContent
      hitsPerPage={hitsPerPage}
      searchSettings={searchSettings}
      requestOptions={requestOptions}
    >
      <RelatedContentByTargetAudienceInner
        contentType={contentType}
        targetAudienceName={targetAudienceName}
        title={title}
        className={className}
      />
    </SearchAllContent>
  );
};

export default RelatedContentByTargetAudience;
